import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "pa-4" };
const _hoisted_2 = { class: "contents-title-text mb-0 text-black" };
const _hoisted_3 = { class: "caption-normal-text mb-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_card = _resolveComponent("v-card");
    const _component_BarogoTooltip = _resolveComponent("BarogoTooltip");
    return (_openBlock(), _createBlock(_component_BarogoTooltip, {
        "without-icon": "",
        "content-class": "tooltip elevation-3 pa-0"
    }, {
        activatorSlot: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.totalDeliveryFee), 1 /* TEXT */)
        ]),
        tooltipMessage: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.lc}delivery_amount_dialog_title`)), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.lc}delivery_amount_dialog_sub_title`)), 1 /* TEXT */)
            ]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card, {
                width: "340",
                elevation: "0"
            }, {
                default: _withCtx(() => [
                    _createCommentVNode(" 배달대행료 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pa-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}delivery_amount`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.deliveryAgencyFee), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 라이더 지원금 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}worker_support_amount`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.workerSupportAmount), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" B2B 프로모션 지원금 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "wh-nw body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}b2b_promotion_support_amount`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.promotionSupportAmount), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 설정할증 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}config_surcharge`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.configSurcharge), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 추가할증 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}irregular_surcharge`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.irregularSurcharge), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 구역할증 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}area_surcharge`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.areaSurcharge), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 상품할증료 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}goods_price_surcharge`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.goodsPriceSurcharge), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" 배차취소패널티 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "px-4 pb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}allocated_cancel_penalty_amount`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "body2-text font-weight-regular text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.allocatedCancelPenaltyAmount), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_divider),
                    _createCommentVNode(" 배달대행료 합계 "),
                    _createVNode(_component_v_row, {
                        justify: "space-between",
                        "no-gutters": "",
                        class: "pa-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "7" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "bottom-no-wrap text-subtitle-1 font-weight-medium brg-color-grey-600 pa-0" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}total_delivery_charge`)), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, { cols: "5" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-medium text-black pa-0 justify-end" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.totalDeliveryFee), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }));
}
